import { useEffect } from "react";
import {
  NavHeader,
  Footer,
  ScrollToTopBtn,
  InfoBottom,
  SubscribeForm,
  VisualPopup,
} from "../components";
import { usePopupVisibility } from "../hooks/usePopupVisibility";

const setFavicon = (faviconPath) => {
  let link = document.querySelector('link[rel="icon"]');
  if (link) {
    link.href = faviconPath;
  } else {
    link = document.createElement("link");
    link.rel = "icon";
    link.href = faviconPath;
    document.head.appendChild(link);
  }
};

export const ProjectLayout = (props) => {
  const { config, project, children, isMobile, pathname } = props;
  const isIntroPage = pathname === `/`;
  const isDiscographyOrMixes =
    pathname.includes("discography") || pathname.includes("mixes");

  const { isPopupVisible, handlePopupClose, handlePopupOpen } =
    usePopupVisibility(isDiscographyOrMixes);

  useEffect(() => {
    if (project) {
      const faviconPath = isIntroPage
        ? "/assets/intro-favicon.svg"
        : `/assets/${project}-favicon.svg`;
      setFavicon(faviconPath);
    }
  }, [project, isIntroPage]);

  // const theme = isMobile ? "theme-dark" : `${config.media.theme}`;

  return (
    <div className={`project-layout ${config.media.theme}`}>
      <VisualPopup
        isIntroPage={isIntroPage}
        isMobile={isMobile}
        project={project}
        config={config}
        isVisible={isPopupVisible}
      />
      <NavHeader
        isMobile={isMobile}
        isIntroPage={isIntroPage}
        project={project}
        title={config.title}
        fontClass={config.fontClass}
      />
      <ScrollToTopBtn isIntroPage={isIntroPage} />
      <main>{children}</main>
      <SubscribeForm
        followersConfig={config?.followersConfig}
        isIntroPage={isIntroPage}
      />
      <InfoBottom
        isMobile={isMobile}
        isIntroPage={isIntroPage}
        logos={config?.logos}
        project={project}
        iconsMenu={config?.iconsMenu}
      />
      <Footer
        isMobile={isMobile}
        isIntroPage={isIntroPage}
        latestMix={config?.latestMix}
        projectTitle={config?.title}
        handlePopupOpen={handlePopupOpen}
        handlePopupClose={handlePopupClose}
        isVisible={isPopupVisible}
      />
    </div>
  );
};
